import React, { Fragment } from 'react';
import { Input, Button, Dropdown } from 'semantic-ui-react';
import axios from 'axios';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import styled from 'styled-components';
import moment from 'moment';
import { withLocalize } from 'react-localize-redux';
import * as API from '../../network/api.js';

import ErrorMessage from './errorMessage';

export const HHStreamUrl = props => {
  const {
    field,
    form: {
      setFieldValue, touched, errors, values
    }, otherProps, endTime, eventSlug, translate
  } = props;
  const hasError = !!(touched[field.name] && errors[field.name]);

  const options = [
    {
      key: 'obs', image: { avatar: true, src: '/img/general/obs-logo.png' }, text: 'OBS', value: 'obs'
    },
    {
      key: 'zoom', image: { avatar: true, src: '/img/general/zoom-logo.png' }, text: 'ZOOM', value: 'zoom'
    }
  ];
  const handleChange = (e, { value }) => {
    values.platform = value;
  };

  return (
    <Fragment>
      <div>
        <Input
          value={field.value}
          onChange={e => setFieldValue(field.name, e.target.value)}
          onBlur={field.onBlur}
          {...otherProps}
          style={{ width: '70%', marginRight: '5%', marginBottom: '1em' }}
        />
        <Button.Group>
          <Button
            type='button'
            color='blue'
            content={translate('generateLink')}
            style={{ marginTop: '0.5em' }}
            onClick={() => {
              const { platform } = values;
              if (platform === 'obs') {
                const expireAt = endTime.format();
                const requestBody = {
                  eventSlug,
                  expireAt,
                  token: props.user.token
                };
                axios.post(API.GET_STREAM_URL, requestBody).then(res => {
                  setFieldValue(field.name, res.data.streamUrl);
                  setFieldValue('streamingKey', res.data.streamKey);
                });
              } else if (platform === 'zoom') {
                const duration = moment.duration(endTime.diff(values.startTime)).asMinutes();
                const requestBody = {
                  duration,
                  title: values.title,
                  startTime: values.startTime
                };
                axios.post(API.EVENT_STREAMING_ZOOM_CREATE_MEETING, requestBody).then(res => {
                  setFieldValue(field.name, res.data.response.streamUrl);
                  setFieldValue('streamingKey', res.data.response.password);
                });
              }
            }}
          />
          <StyledDropdown
            className='button icon'
            floating
            color='blue'
            style={{ marginTop: '0.5em', backgroundColor: '#2185d0', color: 'white' }}
            onChange={handleChange}
            placeholder={values.platform}
            options={options}
          />
        </Button.Group>
      </div>
      <KeyContainer>
        <span style={{ display: 'block' }}>{translate('liveKey')} </span>
        {values.streamingKey}
      </KeyContainer>
      {hasError && (<ErrorMessage error={errors[field.name]} />)}
    </Fragment>
  );
};

const KeyContainer = styled.div`
  margin-top: 2em;
  font-size: 0.92857143em;
  font-weight: 700;
  text-transform: none;
  color: #666666;
`;

const StyledDropdown = styled(Dropdown)`
  margin-top: 0.5em;
  .menu {
    width: 120px
  }
`;

export default compose(withLocalize, connect(({ user }) => ({ user }), null))(HHStreamUrl);



// WEBPACK FOOTER //
// ./src/components/forms/fields/hhStreamUrl.js